import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import universeImage from '../assets/images/universeImage.png';
import moodboostImage from '../assets/images/moodboostImage.png';

import g1 from '../assets/images/g1.png';
import q11 from '../assets/images/design1/web2.PNG';
import railfood from '../assets/images/Railfood.png'
import turtle from '../assets/images/turtle.png';
import ecom from '../assets/images/ecom.png';
import zaiqa from '../assets/images/zaiqa.png';
import thumbnail from '../assets/images/Thumbnail.png';



export default function Portfolio() {
  // Array for websites
  const websites = [
     {
    name: "UNI-verse – University Bulletin App",
    image: universeImage, // import this at the top: import universeImage from '../assets/images/universe.png';
     // Replace with actual Figma or demo link
    githubLink: "https://github.com/HafsaQureshi1/FYP_UNI-verse_f21", // Replace with actual GitHub repo
    description: "UNI-verse is a cross-platform university bulletin board app developed as my final year project. It enables students to post events, lost items, surveys, job listings, and get peer help. Features include AI-based categorization, real-time notifications, and a helpful chatbot."
  },
  {
    name: "Mood Boost – Mental Wellness Game",
    image: moodboostImage, // import this at the top: import moodboostImage from '../assets/images/moodboost.png';
    githubLink: "https://github.com/HafsaQureshi1/MoodJournal-track-your-emotions", // Replace with actual GitHub repo
    description: "Mood Boost is a gamified mobile app that helps users manage emotions, track their mental health, and stay motivated. Designed with playful UI and journal-style tracking, it was built for a Human-Computer Interaction course."
  },
    {
      name: "Ecommerce Website",
      description: "Embark on a cultural journey through our website, where diversity thrives. Explore and celebrate the richness of traditions.",
      link: "https://farhang-official.vercel.app/",
      image: g1,
      githubLink: "https://github.com/HafsaQureshi1/Final_Project_Hafsa_Ali_Sadia.git"
    },

   
  ];

  // Array for design images
 
  return (
    <>
      <section id="portfolio">
        <br /><br />
        <div className="container justify-content-center text-center my-5  wow-delayed ">
          <h3 className="my-4 display-6 fw-bold " style={{ color: 'orangered', fontSize: '32px' }}>Portfolio</h3>
          <h1 className="my-4 display-6 fw-bold ">My Amazing Works</h1>
          <h5 style={{ color: 'gray', fontFamily: 'sans-serif' }}>Here are a few past  projects I've worked on.</h5>
          <br />
          {/* Custom orange dot cursor */}
          <br />
          <Tabs
            defaultActiveKey="ui"
            id="uncontrolled-tab-example"
            className="mb-3 justify-content-center text-center"
            style={{ fontSize: '25px' }}
          >
           <Tab eventKey="home" title="Projects">
  <div className="container-fluid">
    <div className="row my-2 justify-content-center text-center">
      {websites.map((website, index) => (
        <div key={index} style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }} className="my-4 col-12">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-md-6 text-center py-3">
              <a href={website.link} target="_blank" rel="noopener noreferrer">
                <img className="img-fluid rounded" style={{ maxHeight: '350px', objectFit: 'cover' }} src={website.image} alt={website.name} />
              </a>
            </div>

            {/* Right Description */}
            <div className="col-md-5 text-start py-3 px-4">
              <a className="web" href={website.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'black' }}>
                <h3 className="mb-3">{website.name}</h3>
              </a>
              <p className="text-secondary">{website.description}</p>
              <p>
                Github Link:&nbsp;
                <a style={{ color: 'green', textDecoration: 'none' }} href={website.githubLink} target="_blank" rel="noopener noreferrer">
                  Click Here
                </a>
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</Tab>
          <Tab eventKey="ui" title="App UI">
  <div className="container-fluid">
    <div className="col-12 my-4 p-3" style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }}>
        <div className="row align-items-center">
          <div className="col-lg-5 text-start px-4">
            <h2 className="web mt-3">Real State CRM and Messaging App</h2>
            <p className='text-success web'>A mobile-first CRM designed for real estate agents to manage clients, track pipelines, schedule tasks, and streamline communications with integrated email, VoIP, and analytics.</p>
          </div>
          <div className="col-lg-7 text-center">
            <a href="https://www.figma.com/design/pehDwar3tKlFSjuuHbnZC3/Realty-Text-Pro?node-id=128-898&t=bU6rVu1MUrHGTHJH-1" target="_blank" rel="noopener noreferrer">
              <img style={{ width: '100%', borderRadius: '12px' }} className="img-fluid" src={thumbnail} alt="Turtle Traders" />
            </a>
          </div>
        </div>
      </div>

    <div className="row my-2 justify-content-center text-center">
      {/* Railfoods */}
      <div className="col-12 my-4 p-3" style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }}>
        <div className="row align-items-center">
          <div className="col-lg-7 text-center">
            <a href="https://www.figma.com/design/VZpCmSS0gWLx1850kq0ymj/railfoods?node-id=0-1&t=yhtsN4EmrAUHrpZ3-1" target="_blank" rel="noopener noreferrer">
              <img style={{ width: '100%', borderRadius: '12px' }} className="img-fluid" src={railfood} alt="" />
            </a>
          </div>
          <div className="col-lg-5 text-start px-4">
            <h2 className="web mt-3">Food Delivery App Design – Railfood</h2>
            <p className='text-success web'>Railfoods app design features a user-friendly interface optimized for food delivery...</p>
          </div>
        </div>
      </div>

      {/* Turtle Traders */}
      <div className="col-12 my-4 p-3" style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }}>
        <div className="row align-items-center">
          <div className="col-lg-5 text-start px-4">
            <h2 className="web mt-3">Copy Trading App UI – Turtle Traders</h2>
            <p className='text-success web'>This trading app design focuses on intuitive financial dashboards, trader analytics, and seamless navigation for copy investors...</p>
          </div>
          <div className="col-lg-7 text-center">
            <a href="https://www.figma.com/design/eoExzvvAv01S4nQBy4dtbK/Turtle-Traders?node-id=0-1&t=xljjp7i27SYfm1JS-1" target="_blank" rel="noopener noreferrer">
              <img style={{ width: '100%', borderRadius: '12px' }} className="img-fluid" src={turtle} alt="Turtle Traders" />
            </a>
          </div>
        </div>
      </div>

      {/* Loyalty App */}
      <div className="col-12 my-4 p-3" style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }}>
        <div className="row align-items-center">
          <div className="col-lg-6 text-center">
            <a href="https://www.figma.com/design/Ttx1DDuMsVfNw6HuptsFhn/Loyalty-App?node-id=0-1&t=F3Yj2J58Ds8taH9X-1" target="_blank" rel="noopener noreferrer">
              <img style={{ width: '80%', borderRadius: '12px' }} className="img-fluid" src={q11} alt="Loyalty App" />
            </a>
          </div>
          <div className="col-lg-6 text-start px-4">
            <h2 className="web mt-3">Loyalty App Design</h2>
            <p className='text-success web'>Loyalty app design revolves around enhancing user engagement and rewarding customer retention...</p>
          </div>
        </div>
      </div>

      {/* Ecommerce UI Kit */}
      <div className="col-12 my-4 p-3" style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }}>
        <div className="row align-items-center">
          <div className="col-lg-5 text-start px-4">
            <h2 className="web mt-3">Ecommerce UI Kit</h2>
            <p className='text-success web'>A comprehensive ecommerce UI kit featuring product cards, filters, cart flows, and payment pages. Designed for modern online stores with a responsive layout and bold typography.</p>
          </div>
          <div className="col-lg-7 text-center">
            <a href="https://www.figma.com/design/ag85aNQrEMY53ZWw13oj72/Ecommerce-Ui-Kit?node-id=0-1&t=BzfO10kSXOBYKRE9-1" target="_blank" rel="noopener noreferrer">
              <img style={{ width: '100%', borderRadius: '12px' }} className="img-fluid" src={ecom} alt="Ecommerce UI" />
            </a>
          </div>
        </div>
      </div>

      {/* Zaiqa Foods */}
      <div className="col-12 my-4 p-3" style={{ border: '1px solid rgb(240, 240, 240)', borderRadius: '12px' }}>
        <div className="row align-items-center">
          <div className="col-lg-7 text-center">
            <a href="https://www.figma.com/design/tcJl9mNL1S0FVb5rZPqifX/Zaiqa-foods?node-id=0-1&t=n9wrFrPVGljgOUoV-1" target="_blank" rel="noopener noreferrer">
              <img style={{ width: '100%', borderRadius: '12px' }} className="img-fluid" src={zaiqa} alt="Zaiqa Foods" />
            </a>
          </div>
          <div className="col-lg-5 text-start px-4">
            <h2 className="web mt-3">Restaurant App UI – Zaiqa Foods</h2>
            <p className='text-success web'>Zaiqa Foods app is designed for restaurant discovery and food ordering...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</Tab>

          </Tabs>
        </div>
      </section>
    </>
  );
}
